import { jsx, jsxs, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { forwardRef } from "react";
import { WorkingTurnsColors } from "../../foundations/palette.es.js";
import useIsMobile from "../../hooks/use-is-mobile.es.js";
import { Typography } from "../typography/typography.es.js";
import { TicketCardDesktop } from "./components/ticket-card-desktop.es.js";
import { TicketCardMobile } from "./components/ticket-card-mobile.es.js";
import { WorkingTurnAction } from "./components/turn-action-component.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import "@mui/material";
import { TurnIcons as c } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
const TicketCard = forwardRef(function Card({
  turn,
  date,
  productName,
  productRequestedCode,
  actionText,
  ...rest
}, ref) {
  const isMobile = useIsMobile();
  const turnIconToRender = c[turn];
  const turnColor = WorkingTurnsColors[turn];
  const actionTextInputted = actionText ?? "";
  const actionComponent = composeActionComponent(turn, actionTextInputted);
  return isMobile ? /* @__PURE__ */ jsx(TicketCardMobile, { ref, turnIconToRender, turnColor, actionComponent, turn, date, productName, productRequestedCode, ...rest }) : /* @__PURE__ */ jsx(TicketCardDesktop, { ref, turnIconToRender, turnColor, actionComponent, turn, date, productName, productRequestedCode, ...rest });
});
function composeActionComponent(turn, actionText) {
  const actionComponent = WorkingTurnAction[turn];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Typography, { variant: "body2", children: actionText }),
    actionComponent
  ] });
}
export {
  TicketCard
};
//# sourceMappingURL=ticket-card.es.js.map
